<template>
  <div class="fits-for">
    <div v-for="category of fitsFor" :key="category.code" class="fits-for-category">
      <h3 class="fits-for-category__headline">
        {{ category.name }}
      </h3>

      <div class="fits-for-category__container">
        <div v-for="brand of category.nextLevel" :key="brand.code" class="fits-for-category__brand-container">
          <h4 class="fits-for-category__brand-headline">
            {{ brand.name }}
          </h4>

          <div class="grid grid--five grid--no-gap">
            <a
              v-for="chunk of flattenNextLevel(brand)"
              :key="chunk.code"
              :href="chunk.url"
              class="fits-for-category__models-link">{{ chunk.name }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    fitsFor: {
      type: Array,
      required: true
    }
  },

  methods: {
    flattenNextLevel(node) {
      const result = []

      function recurse(current) {
        const { name, code, isModel, url } = current
        result.push({ name, code, isModel, url })

        if (current.nextLevel.length) {
          current.nextLevel.forEach(recurse)
        }
      }

      recurse(node)
      return _.filter(result, item => item.isModel)
    }

  }
}
</script>

<style lang="scss">
.fits-for-category:not(:last-child) {
  margin-bottom: measure(half);
  padding-bottom: measure(half);
}

.fits-for-category__headline {
  @include body-semi-bold;
  margin-top: 0;
  margin-bottom: measure(quarter);
}

.fits-for-category__brand-container {
  display: flex;
  flex-direction: column;
  margin-bottom: measure(half);
  border-top: 1px solid color(border-gray);
  border-left: 1px solid color(border-gray);

  &:last-child {
    margin-bottom: 0;
  }
}

.fits-for-category__brand-headline {
  @include body-smaller-semi-bold;
  display: flex;
  align-items: center;
  min-height: 3.125rem;
  margin: 0;
  padding: measure(eighth) measure(quarter);
  background-color: color(background-white);
  border-bottom: 1px solid color(border-gray);
  border-right: 1px solid color(border-gray);

  @include media(small) {
    min-height: 3.125rem;
    padding: measure(eighth) measure(half);
  }
}

.fits-for-category__container {
  display: flex;
  flex-direction: column;
}
</style>
